"use strict";

var _classCallCheck = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var TokenStorage = /*#__PURE__*/function () {
  function TokenStorage() {
    _classCallCheck(this, TokenStorage);
  }
  _createClass(TokenStorage, null, [{
    key: "sessionStorage",
    get: function get() {
      try {
        return global['sessionStorage'];
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "window",
    get: function get() {
      try {
        return global['window'];
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "storeToken",
    value: function storeToken(continuationToken, productId) {
      if (TokenStorage.canStore) {
        TokenStorage.sessionStorage.setItem(TokenStorage.getKeyName(productId), continuationToken);
      }
    }
  }, {
    key: "getStoredToken",
    value: function getStoredToken(productId) {
      if (!TokenStorage.canStore) {
        return null;
      }
      return TokenStorage.sessionStorage.getItem(TokenStorage.getKeyName(productId));
    }
  }, {
    key: "initialize",
    value: function initialize() {
      if (TokenStorage.canStore) {
        var flag = TokenStorage.sessionStorage.getItem(TokenStorage.initializedFlag);
        // Duplicated tab, cleaning up all stored keys
        if (flag) {
          this.clear();
        }
        TokenStorage.sessionStorage.setItem(TokenStorage.initializedFlag, 'true');
        // When leaving page or refreshing
        TokenStorage.window.addEventListener('unload', function () {
          TokenStorage.sessionStorage.removeItem(TokenStorage.initializedFlag);
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (TokenStorage.canStore) {
        var keyToDelete = [];
        for (var i = 0; i < TokenStorage.sessionStorage.length; i++) {
          var key = TokenStorage.sessionStorage.key(i);
          // We manually removed startsWith here due to some problems with babel polyfill setup.
          // Restore it when we figure out what's wrong.
          //if (key.startsWith(TokenStorage.tokenStoragePrefix)) {
          if (key.indexOf(TokenStorage.tokenStoragePrefix) === 0) {
            keyToDelete.push(key);
          }
        }
        keyToDelete.forEach(function (key) {
          return TokenStorage.sessionStorage.removeItem(key);
        });
        TokenStorage.sessionStorage.removeItem(TokenStorage.initializedFlag);
      }
    }
  }, {
    key: "getKeyName",
    value: function getKeyName(productId) {
      return "".concat(TokenStorage.tokenStoragePrefix).concat(productId);
    }
  }, {
    key: "canStore",
    get: function get() {
      return TokenStorage.sessionStorage && TokenStorage.window;
    }
  }]);
  return TokenStorage;
}();
exports.TokenStorage = TokenStorage;
TokenStorage.initializedFlag = 'twilio_twilsock_token_storage';
TokenStorage.tokenStoragePrefix = 'twilio_continuation_token_';
TokenStorage.initialize();